<template>
	<section class="section">
		<form id="add" class="container">
			<div class="field">
				<label class="label" for="name">Name:</label>
				<input class="input" v-model="recipe.name" name="name" type="text" placeholder="" />
			</div>
			<div class="field">
				<label class="label" for="category">Category:</label>
				<input class="input" v-model="recipe.category" name="category" type="text" placeholder="Category" />
			</div>
			<div class="field">
				<label class="label" for="category">Tags:</label>
				<input class="input" v-model="recipe.tags" name="tags" type="text" placeholder="Comma separated tags" />
			</div>
			<div class="field">
				<label class="label" for="servings">Servings:</label>
				<input class="input" v-model.number="recipe.servings" name="servings" type="number" placeholder="Servings" />
			</div>
			<div class="field">
				<label class="label" for="preptime">Prep time (minutes):</label>
				<input class="input" v-model.number="recipe.preptime" number name="preptime" type="text" placeholder="Prep time" />
			</div>
			<div class="field">
				<label class="label" for="cooktime">Cooking Time (minutes):</label>
				<input class="input" v-model.number="recipe.cooktime" number name="cooktime" type="text" placeholder="Cooking time" />
			</div>
			<div class="field">
				<label class="label" for="source">Source:</label>
				<input class="input" v-model="recipe.source" name="source" type="text" placeholder="Source" />
			</div>
			<div class="field">
				<label class="label" for="ingredients">Ingredients:</label>
				<textarea class="textarea" v-model="recipe.ingredients" name="ingredients"></textarea>
			</div>
			<div class="field">
				<label class="label" for="instructions">Instructions:</label>
				<div class="control">
					<textarea class="textarea" v-model="recipe.instructions" name="instructions"></textarea>
				</div>
			</div>
			<div class="field">
				<label class="label" for="notes">Notes:</label>
				<textarea class="textarea" v-model="recipe.notes" name="notes"></textarea>
			</div>
			<div class="columns is-mobile">
				<div class="column">
					<a class="button is-success is-outlined" v-on:click="save">Save</a>
				</div>
				<div class="column has-text-right">
					<a class="button is-dark is-outlined" v-on:click="cancel">Cancel</a>
				</div>
			</div>
			<!--p><pre>data: {{ $data }}</pre></p-->
		</form>
	</section>
</template>

<script>
	import {db} from '@/variables.js'

	export default {
		data: function () {
			return {
				recipe: {
					ingredients: '',
					instructions: '',
				}
			}
		},
		methods: {
			save: function() {
				var vm = this

				if( this.recipe.tags )
				{
					this.recipe.tags = this.recipe.tags.split(',')
					for( var idx in this.recipe.tags )
					{
						this.recipe.tags[idx] = this.recipe.tags[idx].trim()
					}
					this.recipe.tags.sort()
				}

				if( this.recipe.ingredients )
				{
					this.recipe.ingredients = this.recipe.ingredients.split('\n')
				}

				if( this.recipe.instructions )
				{
					this.recipe.instructions = this.recipe.instructions.split('\n')
				}

				var now = new Date()
				this.recipe.created_at = now.toJSON()

				db.post(this.recipe).then(function(response){
					vm.$router.push('/recipe/'+response.id)
				}).catch(function(error){
					alert(error.message)
					console.log(error)
				})
			},
			cancel: function() {
				if (window.confirm("Are you sure? Data in the form will be lost."))
				{
					this.$router.push('/');
				}
			}
		}
	}
</script>
